const onObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.click();
            observer.unobserve(entry.target);
        }
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const observer = new IntersectionObserver(onObserve, {
        rootMargin: "0px 0px 200px 0px"
    });
    const targets = document.querySelectorAll("button.video-section__poster");
    targets.forEach(target => {
        observer.observe(target);
    });
});
